<template>
  <span>
    <exit v-if="obj.type === 'exit'" :info="obj" />
    <seat
      v-else-if="obj.type === 'seat'"
      :info="obj"
      :passenger="obj.passenger"
      :show-suitable-for-infant="obj.showSuitableForInfant"
      :current-traveler-choosing="obj.currentTravelerChoosing"
      :handle-seat-selection="handle_seat_selection"
    />
    <facility v-else-if="obj.type === 'facility'" :info="obj" />
    <div
      v-else
      :class="(obj.isExitRow ? 'small-map-block' : 'map-block') + ' empty'"
    >
      <span class="block-info">{{ obj.row || '' }}</span>
    </div>
  </span>
</template>

<script>
  import Exit from '@liveflight/components/blocks/seat-map/deck/exit.vue';
  import Seat from '@liveflight/components/blocks/seat-map/seat/seat.vue';
  import Facility from '@liveflight/components/blocks/seat-map/deck/facility.vue';

  export default {
    name: 'seat-map-block',
    components: {
      seat: Seat,
      exit: Exit,
      facility: Facility,
    },
    props: {
      obj: {
        type: Object,
        required: true,
      },
    },
    methods: {
      handle_seat_selection() {
        const { handleSeatSelection } = this.obj;
        if (handleSeatSelection) {
          handleSeatSelection(this.obj);
        }
      },
    },
  };
</script>

<style lang="scss">
  @media screen and (max-width: $seat-map-mobile-breakpoint) {
    $min-unit: 2em;
  }

  .map-block {
    aspect-ratio: 1 / 1;
    min-width: 44px;
    max-width: 44px;
    @media screen and (max-width: $seat-map-mobile-breakpoint) {
      min-width: 32px;
      max-width: 32px;
    }
  }

  .small-map-block {
    aspect-ratio: 1 / 1;
    min-width: 22px;
    max-width: 22px;

    @media screen and (max-width: $seat-map-mobile-breakpoint) {
      min-width: 16px;
      max-width: 16px;
    }
  }

  .block-info {
    font-size: smaller;
    @media screen and (max-width: $seat-map-mobile-breakpoint) {
      font-size: x-small;
    }
  }

  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
</style>
